module.exports = __webpack_public_path__ + "static/customer-service-70ed21e1898923e3f79241d4217d31b4.png";